/**
 * Accessibility Dropdown
 * Handles font size adjustments and animation pause functionality
 */
(function () {
  const STORAGE_KEY_FONT = 'accessibility-font-size';
  const STORAGE_KEY_ANIMATION = 'accessibility-animation';

  const toggleButton = document.querySelector('.navbar__button--accessibility');
  const dropdown = document.getElementById('accessibility-dropdown');

  if (!toggleButton || !dropdown) {
    return;
  }

  const fontButtons = dropdown.querySelectorAll('[data-font-size]');
  const animationButtons = dropdown.querySelectorAll('[data-animation]');

  /**
   * Toggle dropdown visibility
   *
   * @param {boolean} show - Whether to show or hide the dropdown
   */
  function toggleDropdown(show) {
    const isExpanded =
      show !== undefined
        ? show
        : toggleButton.getAttribute('aria-expanded') === 'false';

    toggleButton.setAttribute('aria-expanded', isExpanded);
    dropdown.setAttribute('aria-hidden', !isExpanded);

    if (isExpanded) {
      // Focus first button in dropdown
      const firstButton = dropdown.querySelector(
        '.accessibility-dropdown__btn'
      );
      if (firstButton) {
        setTimeout(() => firstButton.focus(), 100);
      }
    }
  }

  /**
   * Close dropdown when clicking outside
   *
   * @param {Event} event - The click event
   */
  function handleClickOutside(event) {
    if (
      !dropdown.contains(event.target) &&
      !toggleButton.contains(event.target)
    ) {
      toggleDropdown(false);
    }
  }

  /**
   * Handle escape key to close dropdown
   *
   * @param {KeyboardEvent} event - The keyboard event
   */
  function handleEscape(event) {
    if (
      'Escape' === event.key &&
      'false' === dropdown.getAttribute('aria-hidden')
    ) {
      toggleDropdown(false);
      toggleButton.focus();
    }
  }

  /**
   * Apply font size setting
   *
   * @param {string} size - Font size setting: 'default', 'big', or 'biggest'
   */
  function applyFontSize(size) {
    document.documentElement.classList.remove(
      'font-size-default',
      'font-size-big',
      'font-size-biggest'
    );

    if ('default' !== size) {
      document.documentElement.classList.add(`font-size-${size}`);
    }

    fontButtons.forEach((btn) => {
      const isActive = btn.dataset.fontSize === size;
      btn.setAttribute('aria-pressed', isActive);
    });

    try {
      localStorage.setItem(STORAGE_KEY_FONT, size);
    } catch (e) {
      // localStorage might be disabled
    }
  }

  /**
   * Apply animation setting
   *
   * @param {string} state - Animation state: 'enabled' or 'paused'
   */
  function applyAnimation(state) {
    if ('paused' === state) {
      document.body.classList.add('animations-paused');
    } else {
      document.body.classList.remove('animations-paused');
    }

    animationButtons.forEach((btn) => {
      const isActive = btn.dataset.animation === state;
      btn.setAttribute('aria-pressed', isActive);
    });

    try {
      localStorage.setItem(STORAGE_KEY_ANIMATION, state);
    } catch (e) {
      // localStorage might be disabled
    }
  }

  /**
   * Load saved preferences
   */
  function loadPreferences() {
    try {
      const savedFont = localStorage.getItem(STORAGE_KEY_FONT) || 'default';
      const savedAnimation =
        localStorage.getItem(STORAGE_KEY_ANIMATION) || 'enabled';

      applyFontSize(savedFont);
      applyAnimation(savedAnimation);
    } catch (e) {
      // Use defaults if localStorage is unavailable
      applyFontSize('default');
      applyAnimation('enabled');
    }
  }

  // Event listeners
  toggleButton.addEventListener('click', () => toggleDropdown());
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('keydown', handleEscape);

  fontButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      applyFontSize(btn.dataset.fontSize);
    });
  });

  animationButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      applyAnimation(btn.dataset.animation);
    });
  });

  // Load preferences on page load
  loadPreferences();
})();
